require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/is-iterable.js
// module id = 788
// module chunks = 2